import { ContributionStatus } from './contributionStatus';

export const LeadMagnetStatus = ContributionStatus;
